module.exports = function() {
  return new Worker(__webpack_public_path__ + "213eb228323e75a6609c.worker.js");
};